/**
 * 1.0 물리 포맷 날짜 문자열 → 화면 표기. BE 는 옛 컬럼 값을 그대로 준다
 * (clsDate/plnDate=yyyyMMdd, insDate/updDate=yyyyMMddHHmmss).
 * 디자인 데모 표기: 일자 `2026-07-14`, 일시 `2026-07-13 09:12`(초 없음).
 * 포맷 밖 값(빈 값·이형 데이터)은 그대로 노출한다 — 데이터를 숨기지 않는다.
 * 재고이동내역조회(est05)·재고이동확정(est04)이 함께 쓴다.
 */

/** yyyyMMdd → YYYY-MM-DD. */
export const formatDate8 = (value: unknown): string => {
  const v = typeof value === 'string' ? value : ''
  if (!/^\d{8}$/.test(v)) return v
  return `${v.slice(0, 4)}-${v.slice(4, 6)}-${v.slice(6, 8)}`
}

/** yyyyMMddHHmmss → YYYY-MM-DD HH:mm. */
export const formatDateTime14 = (value: unknown): string => {
  const v = typeof value === 'string' ? value : ''
  if (!/^\d{14}$/.test(v)) return v
  return `${v.slice(0, 4)}-${v.slice(4, 6)}-${v.slice(6, 8)} ${v.slice(8, 10)}:${v.slice(10, 12)}`
}
